import React, { useRef } from 'react';
// @ts-ignore
import { useTabIndex } from 'react-tabindex';
import styled from 'styled-components';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const StyledInput = styled.input`
  display: block;
  padding: 13.5px;
  border: 1.5px solid #DADEE2;
  box-shadow: 0 0 0 1px #DADEE2;
  background-color: white;
  color: #242325;
  font: normal normal normal 20px/24px Lato;
  width:100%;
  text-align: center;
  border-radius:10px;

  &:focus {
    outline: 0;
    border: 1.5px solid #26375f;
    box-shadow: 0 0 0 1px #26375f;
  }

  &:hover {
    border: 1.5px solid #26375f;
    box-shadow: 0 0 0 1px #26375f;
  }
`;

const Input = (props: Props) => {
  const tabIndex: number = useTabIndex();
  const input = useRef<HTMLInputElement>(null);
  return (
    <StyledInput
      tabIndex={tabIndex}
      ref={input}
      {...props}
      onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (input === null || input.current === null) return;
        if (event.charCode === 13) input.current.blur();
      }}
    />
  );
};

export default Input;
